import { render } from "./AdminRiderCreate.vue?vue&type=template&id=0688e777&scoped=true&ts=true&lang=true"
import script from "./AdminRiderCreate.vue?vue&type=script&lang=ts"
export * from "./AdminRiderCreate.vue?vue&type=script&lang=ts"

import "./AdminRiderCreate.vue?vue&type=style&index=0&id=0688e777&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0688e777"]])

export default __exports__